export default __webpack_public_path__ + "static/media/KZ.М.02.2243 black.ef60538c.svg";